// Modules
import React from 'react';
import _ from 'lodash';

import { FormCard } from 'components/content-containers/cards';
import { PageContent } from 'components/page';
import Form from 'services/data/form';
import FormForm from 'components/models/company/form-form';
import SVG from 'components/widgets/icons/svg';
import appHistory from 'app-history';

import * as actions from '../store/actions';


export default function FormAdd({ id }) {
  const { data: company } = actions.useCompany(id);
  const { refetch } = actions.useCompanyForms(id);

  if (!company) return null;

  const onSubmit = values => {
    const create = _.clone(values);

    return Form.create(create)
      .then(() => refetch())
      .then(() => {
        appHistory.push(`/companies/${company.id}/forms`);
      });
  };

  const initialValues = { company: company.id };

  return (
    <PageContent className="bg-medium-blue-grey">
      <div className="form-summary flex flex-equal-children">
        <FormCard className="form-form">
          <div className="form-header">
            <SVG src="svg/checklist.svg" className="form-icon" />
            <h5 className="form-title">Add Form</h5>
          </div>
          <FormForm
            initialValues={initialValues}
            onSubmit={onSubmit}
          />
        </FormCard>
      </div>
    </PageContent>
  );
}



// WEBPACK FOOTER //
// ./app/routes/company/sub-routes/form-add.js